import React from 'react'
import Navbar from '../components/Navbar'
import Search from '../components/Search'

const Searchpage = () => {
  return (
    <>
      <Navbar/>
      <Search/>
    </>
  )
}

export default Searchpage
